import * as React from 'react';

interface SaveSearchState {
    //sample
    Prop1: any
    Prop2: any
}

export class SaveSearch extends React.Component<any, SaveSearchState> {

    constructor(props: any) {
        super(props);

        this.state = { Prop1: '', Prop2: '' };
    }

    //CancelHandler() {
    //    RCNGWindow.ConfirmWindow.showConfirmBox("You are going to exist.  Are you sure you want to continue?", this.onOkCancel.bind(this), this.onCancelWizard.bind(this));
    //    //this.props.cancelForm();
    //}

    //onOkCancel() {
    //    this.props.cancelForm();
    //}

    //onCancelWizard() {
    //    RCNGWindow.ConfirmWindow.close();
    //}

    public render() {

        return <div className='dashboard-layout-alert'>

            <div className='alert alert-info'>
                <ul className="ps-3 layout-info">
                    <li>Saved searches are unique to each platform user.</li>
                    <li className="mt-1">To save search criteria for later use, select <span className='fw-semibold '>Create New Saved Search </span> in the Saved Searches list. The platform will ask for a search name. After the search is executed, the search name will become an entry in the Saved Searches list. Later, whenever the search name is selected, the platform will recall and fill out the search criteria.</li>
                    <li className="mt-1">To change the search criteria for a saved search, select the search name from the Saved Searches list and change the search criteria as desired. When the search is executed, the platform will ask if the saved search should be updated with the current search criteria.</li>
                    <li className="mt-1">To delete a saved search, select the delete icon next to the search name in the Saved Searches list. The platform will ask for confirmation before deleting the saved search.</li>
                    <li className="mt-1">To have the platform execute a default search at the time a dashboard is loaded, check “Default” when creating or changing a saved search while you are viewing the desired Dashboard.</li>
                    <li className="mt-1"> If a default search is enabled and a default is no longer desired, select the default search name from the Saved Searches list and uncheck “Default”. The platform will ask for confirmation before making the search a standard, non-default search.</li>
                </ul>



            </div>
        </div>;
    }
}